import { useQuery } from "@tanstack/react-query";
import { useAuth } from "context/auth-context";
import { bonusStatusDetailsApi } from "pages/MyReferralPage/MyReferralPage.api";

export function useBonusPoints() {
  const { auth } = useAuth();
  if (auth?.panelistId) {
    const result = useQuery(
      ["bonusPointsDetails", auth?.panelistId],
      async () => {
        return bonusStatusDetailsApi(auth?.panelistId);
      },
      {
        enabled: !!auth?.panelistId,
        refetchOnWindowFocus: false,
      }
    );
    return typeof result !== undefined ? result?.data : null;
  }
}